import { usePageSectionContext } from '@/components/page-sections/page-section-context';
import { useIsPageEditor } from '@/hooks/use-is-page-editor';
import { hasRichTextContent } from '@/lib/rich-text';

export function useShowPinnedSectionText(pinnedHeading: string, pinnedDescription?: string) {
  const isEditor = useIsPageEditor();
  const sectionContext = usePageSectionContext();
  const isStaticPreview = sectionContext != null && sectionContext.renderMode !== 'default';

  return (
    (isEditor && !isStaticPreview) ||
    hasRichTextContent(pinnedHeading) ||
    hasRichTextContent(pinnedDescription)
  );
}
